<template lang="html">
    <article class="page-rightsInterests">
        <div class="head">
            <e-breadcrumb :nav="nav"></e-breadcrumb>
        </div>
        <div v-for="(lists,key) in renderData" class="rightsInterests-sec" :key="key">
            <app-panel :title="key | formatType">
                <ul slot="content" class="rightsInterests-lists clearfix">
                    <li v-for="(item,i) in lists" :key="i" class="rightsInterests-card">
                        <list-card :list="item"></list-card>
                    </li>
                </ul>
            </app-panel>
        </div>
    </article>
</template>

<script>
import appPanel from 'components/Panel/index'
import listCard from './components/card.vue'
import rightsInterests from 'mixins/rightsInterests'
export default {
    mixins: [rightsInterests],
    data () {
        return {
            nav: [{
                name: '用户中心',
                to: '/account'
            }, {
                name: '我的权益',
                to: '/tab'
            }]
        }
    },
    computed: {
        renderData () {
            let result = {}
            this.initData.forEach(item => {
                // 分组
                if (result[item.useType]) {
                    result[item.useType].push(item)
                } else {
                    result[item.useType] = []
                    result[item.useType].push(item)
                }
            })
            // console.log(result, '初始渲染数据')
            return result
        }
    },
    filters: {
        formatType (val) {
            let opt = {
                1: '轻松制作',
                2: '品牌推广',
                3: '智能营销',
                4: '特权服务',
                5: '新功能体验',
                6: '深度分析',
                7: '品牌无忧'
            }
            return opt[val]
        }
    },
    components: { appPanel, listCard }
}
</script>

<style lang="scss">
@import 'styles/mixin.scss';
article.page-rightsInterests{
    padding: 30px;
    .head{
        margin-bottom: 20px;
        a.back::before{
            margin-left: 20px;
            color: #1261ff !important;
            @include arrow-left;
        }
    }
    .rightsInterests-sec:last-child{
        margin-bottom: 0;
    }
}
.rightsInterests-sec{
    margin-bottom: 20px;
    .rightsInterests-lists{

        .rightsInterests-card{
                float: left;
                margin-right: 17px;
                margin-bottom: 20px;
        }
    }

}
</style>
